import { render, staticRenderFns } from "./reviewVideoReplay.vue?vue&type=template&id=06e611e6&scoped=true"
import script from "./reviewVideoReplay.vue?vue&type=script&lang=js"
export * from "./reviewVideoReplay.vue?vue&type=script&lang=js"
import style0 from "./reviewVideoReplay.vue?vue&type=style&index=0&id=06e611e6&prod&lang=scss&scoped=true"
import style1 from "./reviewVideoReplay.vue?vue&type=style&index=1&id=06e611e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e611e6",
  null
  
)

export default component.exports